// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + "app" + "." + "332d9c59" + ".chunk.css");